var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTurboram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 61,
    viewBox: "0 0 49 61",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3418 0.916748L48.1663 12.7666L48.1662 12.7667V46.3141L22.6574 60.0833V60.0834L22.6573 60.0834L22.6572 60.0834V60.0833L0.833008 48.3029V14.686L26.3418 0.916748Z",
    fill: "#70706F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84863 17.4092V51.0103L20.4542 58.8942V25.3396L5.84863 17.4092ZM18.9613 56.0315L7.34149 49.7592V20.2719L18.9613 26.5811V56.0315Z",
    fill: "#585857"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77441 16.3186L4.16568 16.5298V50.1468L3.77441 49.9356V16.3186Z",
    fill: "#585857"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833008 14.686L5.84867 17.4094V51.0103L20.4542 58.8941V25.3397L22.6574 26.5359V60.0835L0.833008 48.303V14.686ZM3.53746 30.1961L1.07099 28.8648V34.6833L3.53746 36.0147V30.1961Z",
    fill: "#C7C7C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44828 30.8467V37.6269C4.44828 37.6762 4.57668 37.7162 4.73507 37.7162C4.89346 37.7162 5.02183 37.6762 5.02183 37.6269V30.8467H4.44828Z",
    fill: "#9C9B9B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73504 30.936C4.89343 30.936 5.02183 30.8961 5.02183 30.8468C5.02183 30.7975 4.89343 30.7576 4.73504 30.7576C4.57664 30.7576 4.44824 30.7975 4.44824 30.8468C4.44824 30.8961 4.57664 30.936 4.73504 30.936Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05428 34.9765L4.44824 34.9903L4.49056 36.5683L5.0966 36.5544C5.4313 36.5468 5.69318 36.1873 5.68148 35.7516C5.6698 35.3159 5.38902 34.9688 5.05428 34.9765Z",
    fill: "#70706F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4914 36.5682C4.82611 36.5601 5.08769 36.2003 5.07567 35.7646C5.06364 35.3289 4.78255 34.9822 4.44784 34.9903C4.11313 34.9983 3.85155 35.3581 3.86358 35.7939C3.8756 36.2296 4.15669 36.5763 4.4914 36.5682Z",
    fill: "#B2B2B2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73504 35.0137C4.89343 35.0137 5.02183 35 5.02183 34.9832C5.02183 34.9663 4.89343 34.9526 4.73504 34.9526C4.57664 34.9526 4.44824 34.9663 4.44824 34.9832C4.44824 35 4.57664 35.0137 4.73504 35.0137Z",
    fill: "#9C9B9B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3418 0.916748L48.1663 12.7666L22.6574 26.5359L0.833008 14.686L26.3418 0.916748Z",
    fill: "#D9D9D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurboram);
export default __webpack_public_path__ + "static/media/turboram.427473f0c8c10fc284e3f942e65fb12d.svg";
export { ForwardRef as ReactComponent };